/**
 * @ngdoc overview
 * @name cbl.mitomanager.wa
 * @description Modulo funzionale dell'applicazione MITOMANAGER
 */
((windows) => {
    'use strict';
    angular.module('cbl.mitomanager.wa', [
        'ui.router',
        'ui.bootstrap',
        'ui.grid',
        'ui.grid.autoResize',
        'ui.grid.cellNav',
        'ui.grid.edit',
        'ui.grid.exporter',
        'ui.grid.grouping',
        'ui.grid.pagination',
        'ui.grid.resizeColumns',
        'ui.grid.rowEdit',
        'ui.grid.selection',
        'ui.grid.treeView',
        'ngSanitize',
        'cbl.common'
    ]);
})(window);